import axiosClient from "api/axios_client.js";

const apiDesignationDirectory = {
  create: (payload) => axiosClient.post(`/directories/business-master/designation/create`, payload),
  update: (id, payload) => axiosClient.put(`/directories/business-master/designation/update/${id}`, payload),
  getById: (id) => axiosClient.get(`/directories/business-master/designation/get-by-id/${id}`),
  updateStatus: (payload) => axiosClient.post(`/directories/business-master/designation/update-status`, payload),


  getAllDesignation: (payload) => axiosClient.post(`/directories/business-master/designation/get-all`, payload),
  delete: (ids) => axiosClient.delete(`/directories/business-master/designation/delete`, { data: { ids } }),
};

export default apiDesignationDirectory;


